const featuredImages = [
    "4NLHx8ixJilha14k1UlK",
    "4Kd2OtRZ4VrglMM0r35B",
    "3gRmNbTHac12YZl8EbNq",
    "iKonJh9Kz6NUjf3pc68j",
    "Gv1wzfIibGg3M2Ws9m9k",
    "cSniSgBNPdzWRZz2IiqR",
    "1DBN0yShwUhb0mIqjym2"
]

export default featuredImages